
// 入库单搜索
export const inSearchConfig = function (supplierList, shopUserList, typeList) {
    let searchConfigs = [
        {
            label: $t('storage::in-stock::bill_num'),
            key: 'stock_no_string',
            searchType: 'input',
            componentData: {
                clearable: true,
                placeholder: $t('storage::in-stock::bill_num_input')
            },
        },
        {
            label: $t('storage::in-stock::in_type'),
            key: 'stock_type',
            searchType: 'select',
            componentData: {
                dictKey: 'stock_type',
                clearable: true,
                options: typeList,
                placeholder: $t('storage::in-stock::in_type_select')
            },
        },
        {
            label: $t('storage::in-stock::auditor'),
            key: 'auditors',
            searchType: 'select',
            componentData: {
                dictKey: 'auditors',
                clearable: true,
                options: shopUserList,
                placeholder: $t('storage::in-stock::auditor_select')
            },
        },
        {
            label: $t('storage::in-stock::creator'),
            key: 'applicant',
            searchType: 'select',
            componentData: {
                dictKey: 'applicant',
                clearable: true,
                options: shopUserList,
                placeholder: $t('storage::in-stock::creator_select')
            },
        },
        {
            label: $t('storage::in-stock::audit_time'),
            key: 'audit_time',
            searchType: 'selectDatepicker',
            componentData: {
                options: [
                    { keys: ['audit_time_start', 'audit_time_end'] },
                ],
                dateComponentData: {
                    startPlaceholder: $t('storage::in-stock::start_time'),
                    endPlaceholder: $t('storage::in-stock::end_time')
                },
                clearable: true,
            },
        },
        {
            label: $t('storage::in-stock::create_time'),
            key: 'create_time',
            searchType: 'selectDatepicker',
            componentData: {
                options: [
                    { keys: ['create_time_start', 'create_time_end'] },
                ],
                dateComponentData: {
                    startPlaceholder: $t('storage::in-stock::start_time'),
                    endPlaceholder: $t('storage::in-stock::end_time')
                },
                clearable: true,
            },
        },
        {
            label: $t('storage::in-stock::supplier'),
            key: 'supplier_id',
            searchType: 'select',
            componentData: {
                dictKey: 'supplier_id',
                clearable: true,
                options: supplierList,
                placeholder: $t('storage::in-stock::supplier_select_holder')
            },
        },
        {
            label: $t('storage::in-stock::status'),
            key: 'status',
            searchType: 'select',
            componentData: {
                dictKey: 'status',
                clearable: true,
                placeholder: $t('storage::in-stock::status_select'),
                options: [
                    { label: $t('storage::in-stock::un_audit'), value: 1 },
                    { label: $t('storage::in-stock::has_audit'), value: 2 },
                    { label: $t('storage::in-stock::closed'), value: 3 }
                ],
            },
        },
    ]
    return searchConfigs;
}

// 入库明细搜索
export const inStorageConfig = function (supplierList, shopUserList, typeList) {
    let searchConfigs = [
        {
            label: '单号',
            key: 'stock_no_string',
            searchType: 'input',
            componentData: {
                placeholder: '请输入单号',
                clearable: true
            },
        },
        {
            label: '入库类型',
            key: 'stock_type',
            searchType: 'select',
            componentData: {
                dictKey: 'stock_type',
                placeholder: '请选择入库类型',
                clearable: true,
                options: typeList,
            },
        },
        {
            label: '审核人',
            key: 'auditors',
            searchType: 'select',
            componentData: {
                dictKey: 'auditors',
                placeholder: '请选择审核人',
                clearable: true,
                options: shopUserList,
            },
        },
        {
            label: '创建人',
            key: 'applicant',
            searchType: 'select',
            componentData: {
                dictKey: 'applicant',
                placeholder: '请选择创建人',
                clearable: true,
                options: shopUserList,
            },
        },
        {
            label: '审核时间',
            key: 'audit_time',
            searchType: 'selectDatepicker',
            componentData: {
                options: [
                    { keys: ['audit_time_start', 'audit_time_end'] },
                ],
                dateComponentData: {
                    startPlaceholder: '开始时间',
                    endPlaceholder: '结束时间'
                },
                clearable: true,
            },
        },
        {
            label: '创建时间',
            key: 'create_time',
            searchType: 'selectDatepicker',
            componentData: {
                options: [
                    { keys: ['create_time_start', 'create_time_end'] },
                ],
                dateComponentData: {
                    startPlaceholder: '开始时间',
                    endPlaceholder: '结束时间'
                },
                clearable: true,
            },
        },
        {
            label: '供应商',
            key: 'supplier_id',
            searchType: 'select',
            componentData: {
                dictKey: 'supplier_id',
                placeholder: '请选择供应商',
                clearable: true,
                options: supplierList,
            },
        }
    ]
    return searchConfigs;
}

export const IN_STORAGE_COLUMNS = [
    {
        label: $t('storage::in-stock::table_bill_num'),
        prop: 'stockNo',
        minWidth: 240,
        fixed: 'left'
    },
    {
        label: $t('storage::in-stock::table_releate_num'),
        prop: 'sourceNo',
        minWidth: 240
    },
    {
        label: $t('storage::in-stock::table_supplier'),
        prop: 'supplierName',
        minWidth: 180
    },
    {
        label: $t('storage::in-stock::table_type'),
        prop: 'stockTypeName',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::table_creator'),
        prop: 'applicantName',
        minWidth: 150
    },
    {
        label: $t('storage::in-stock::table_create_time'),
        prop: 'createTime',
        minWidth: 200
    },
    {
        label: $t('storage::in-stock::table_auditor'),
        prop: 'auditorName',
        minWidth: 270
    },
    {
        label: $t('storage::in-stock::table_instock_time'),
        prop: 'operTime',
        minWidth: 200
    },
    {
        label: $t('storage::in-stock::table_status'),
        prop: 'status',
        minWidth: 130,
        fixed: 'right'
    },
    {
        label: $t('storage::in-stock::table_opt'),
        prop: 'opt',
        minWidth: 210,
        fixed: 'right'
    },
]

// 入库明细表格
export const IN_STORAGE_DETAIL_COLUMNS = [
    {
        label: $t('storage::in-stock::order_num'),
        prop: 'stockNo',
        minWidth: 240,
        fixed: 'left'
    },
    {
        label: $t('storage::in-stock::order_sku'),
        prop: 'skuId',
        minWidth: 150,
        fixed: 'left'
    },
    {
        label: $t('storage::in-stock::prod_name'),
        prop: 'title',
        minWidth: 200
    },
    {
        label: $t('storage::in-stock::instock_type'),
        prop: 'stockTypeName',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::instock_num'),
        prop: 'qty',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::total_amount'),
        prop: 'totalPrice',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::creator'),
        prop: 'applicantName',
        minWidth: 150
    },
    {
        label: $t('storage::in-stock::create_time'),
        prop: 'createTime',
        minWidth: 200
    },
    {
        label: $t('storage::in-stock::auditor'),
        prop: 'auditorName',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::audit_time'),
        prop: 'auditTime',
        minWidth: 200
    }
]

// 入库单表格
export const IN_STORAGE_ORDER_COLUMNS = [
    {
        label: $t('storage::in-stock::order_sku'),
        prop: 'skuId',
        minidth: 250
    },
    {
        label: $t('storage::in-stock::prod_name'),
        prop: 'spuName',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::instock_amount'),
        prop: 'qty',
        minWidth: 120
    },
    {
        label: $t('storage::in-stock::total_amount'),
        prop: 'totalPrice',
        minWidth: 120
    },
    {
        prop: 'opt',
        minWidth: '100px',
        label: $t('storage::in-stock::table_opt')
    }
]


export const ORDER_STATUS = {
    1: { label: $t('storage::in-stock::un_audit'), color: '#0000ff' },
    2: { label: $t('storage::in-stock::has_audit'), color: '#00c086' },
    3: { label: $t('storage::in-stock::closed'), color: '#d9001b' }
}
